import React, { forwardRef } from 'react';

const IcStatusAlert = forwardRef(
  (properties, ref) => /* @__PURE__ */ React.createElement("svg", {
    fill: "none",
    height: "16",
    viewBox: "0 0 16 16",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg",
    ...properties,
    ref
  }, /* @__PURE__ */ React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 7.95V8a4 4 0 0 1-4 4H5a4 4 0 0 1 0-8h4.337a3.486 3.486 0 0 0-.302 2H5a2 2 0 1 0 0 4h6a2 2 0 0 0 1.737-1.008A3.49 3.49 0 0 0 15 7.95Z",
    fill: "var(--warning-icon-strong-default)",
    fillRule: "evenodd"
  }), /* @__PURE__ */ React.createElement("circle", {
    cx: "12.5",
    cy: "5.5",
    fill: "var(--color-status-warning-strong)",
    r: "3",
    stroke: "#fff"
  }))
);

export { IcStatusAlert };
//# sourceMappingURL=ic-status-alert.js.map
